import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToolTasks = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.934 22c-.533 0-.99-.189-1.367-.567A1.863 1.863 0 0 1 3 20.065V5.745c0-.533.19-.989.567-1.367a1.865 1.865 0 0 1 1.367-.566H9.65c.148-.521.45-.954.908-1.297.456-.342.97-.515 1.536-.515.59 0 1.111.172 1.563.515.452.342.752.775.9 1.296h4.698c.533 0 .989.189 1.368.566.378.378.567.834.567 1.368v14.32c0 .534-.19.99-.567 1.368a1.865 1.865 0 0 1-1.369.567H4.934Zm0-1.605h14.321a.318.318 0 0 0 .226-.102.319.319 0 0 0 .103-.227V5.745a.315.315 0 0 0-.102-.227.315.315 0 0 0-.227-.102H16.91v2.798H7.28V5.416H4.934a.315.315 0 0 0-.226.102.314.314 0 0 0-.102.227v14.32c0 .082.033.158.102.226a.313.313 0 0 0 .225.104Zm7.16-14.856a.942.942 0 0 0 .967-.967.94.94 0 0 0-.967-.967.94.94 0 0 0-.966.966c0 .276.092.507.276.69a.936.936 0 0 0 .69.278Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m8.2 14.428-1.866-1.777.61-.58 1.242 1.182 2.484-2.364.61.594-3.08 2.945Zm4.276 3.184v-.835h4.969v.835h-4.969Zm0-4.238v-.833h4.969v.834h-4.969Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: .444
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.14 17.833a.671.671 0 0 0 .494-.2.673.673 0 0 0 .2-.495.67.67 0 0 0-.2-.495.676.676 0 0 0-.495-.199.67.67 0 0 0-.495.2.675.675 0 0 0-.2.495.67.67 0 0 0 .2.495.673.673 0 0 0 .496.199Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 1.111
		})
	]
});
export default SvgToolTasks;
